import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useSwitchgearDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["switchgearDelete"],
    async (switchgearAssetId: number) => apiContext.hvSubstationApis.deleteHvSurveyableAsset(switchgearAssetId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
